// Centralized contact details for CONSTANTINOV LTD
export const CONTACT = {
  company: "CONSTANTINOV LTD",
  address: {
    line1: "58 School Road",
    line2: "Dagenham",
    city: "London",
    postcode: "RM10 9QJ",
  },
  // Ion = primary for calls & WhatsApp
  primary: {
    name: "Ion",
    tel: "+447591836115",
    display: "07591 836115",
    role: "",
  },
  secondary: {
    name: "Gheorghe",
    tel: "+447517736847",
    display: "07517 736847",
    role: "",
  },
  email: "constantinovltd@gmail.com",
  whatsapp: "https://wa.me/447591836115",
  legal: {
    companyNumber: "13960088",
    vatNumber: "450754788",
    utrNumber: "2423500071",
  },
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Demolition", to: "/demolition-strip-out-london" },
  { label: "Areas", to: "/#areas" },
  { label: "Contact", to: "/#contact" },
];
